import React from 'react';
import { motion } from 'framer-motion';
import { EmployerAuthorization } from '../../types';
import { formatCurrency, getStatusColor } from '../../utils/calculations';
import { User, CheckCircle, XCircle, Clock } from 'lucide-react';
interface EmployeeCardProps {
  auth: EmployerAuthorization;
  onApprove: (id: string) => void;
  onReject: (id: string) => void;
}
export function EmployeeCard({
  auth,
  onApprove,
  onReject
}: EmployeeCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-1082">
      <div className="flex justify-between items-start mb-4" data-id="element-1083">
        <div className="flex items-center" data-id="element-1084">
          <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 mr-3" data-id="element-1085">
            <User className="h-5 w-5" data-id="element-1086" />
          </div>
          <div data-id="element-1087">
            <h4 className="text-sm font-bold text-gray-900" data-id="element-1088">
              {auth.employeeName}
            </h4>
            <p className="text-xs text-gray-500" data-id="element-1089">ID: {auth.employeeId}</p>
          </div>
        </div>
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(auth.status)}`} data-id="element-1090">
          {auth.status}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-1091">
        <div className="bg-gray-50 p-3 rounded-lg" data-id="element-1092">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1093">Rent Deduction</p>
          <p className="text-sm font-bold text-gray-900" data-id="element-1094">
            {formatCurrency(auth.rentAmount)}
          </p>
        </div>
        <div className="bg-gray-50 p-3 rounded-lg" data-id="element-1095">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1096">Frequency</p>
          <p className="text-sm font-bold text-gray-900" data-id="element-1097">Monthly</p>
        </div>
      </div>

      {auth.status === 'pending' && <div className="flex gap-3" data-id="element-1098">
          <button onClick={() => onApprove(auth.id)} className="flex-1 flex items-center justify-center py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" data-id="element-1099">
            <CheckCircle className="h-4 w-4 mr-2" data-id="element-1100" />
            Approve
          </button>
          <button onClick={() => onReject(auth.id)} className="flex-1 flex items-center justify-center py-2 px-4 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500" data-id="element-1101">
            <XCircle className="h-4 w-4 mr-2 text-red-500" data-id="element-1102" />
            Reject
          </button>
        </div>}

      {auth.status === 'approved' && <div className="text-xs text-gray-500 flex items-center" data-id="element-1103">
          <Clock className="h-3 w-3 mr-1" data-id="element-1104" />
          Approved on {new Date(auth.approvedAt!).toLocaleDateString()}
        </div>}
    </motion.div>;
}